var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "price-list-display" }, [
    _vm.priceList.ProductComponents[0].Energy1Description
      ? _c("div", { staticClass: "product-component-detail highlight price" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.priceList.ProductComponents[0].Energy1Description) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _vm.showVat
            ? _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.getFixedPrice(
                        _vm.priceList.ProductComponents[0].Energy1Price,
                        2
                      )
                    ) +
                    "\n            " +
                    _vm._s(
                      _vm.priceList.ProductComponents[0].Energy1PriceUnit
                    ) +
                    "\n        "
                )
              ])
            : _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.getFixedPrice(
                        _vm.priceList.ProductComponents[0].Energy1PriceNoVAT,
                        2
                      )
                    ) +
                    "\n            " +
                    _vm._s(
                      _vm.priceList.ProductComponents[0].Energy1PriceUnit
                    ) +
                    "\n        "
                )
              ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.priceList.ProductComponents[0].Energy2Description
      ? _c("div", { staticClass: "product-component-detail highlight price" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.priceList.ProductComponents[0].Energy2Description) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _vm.showVat
            ? _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.getFixedPrice(
                        _vm.priceList.ProductComponents[0].Energy2Price,
                        2
                      )
                    ) +
                    "\n            " +
                    _vm._s(
                      _vm.priceList.ProductComponents[0].Energy2PriceUnit
                    ) +
                    "\n        "
                )
              ])
            : _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.getFixedPrice(
                        _vm.priceList.ProductComponents[0].Energy2PriceNoVAT,
                        2
                      )
                    ) +
                    "\n            " +
                    _vm._s(
                      _vm.priceList.ProductComponents[0].Energy2PriceUnit
                    ) +
                    "\n        "
                )
              ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.priceList.ProductComponents[0].Energy1BundleDescription
      ? _c("div", { staticClass: "product-component-detail highlight price" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.priceList.ProductComponents[0].Energy1BundleDescription
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _vm.showVat
            ? _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.getFixedPrice(
                        _vm.priceList.ProductComponents[0].Energy1BundlePrice,
                        2
                      )
                    ) +
                    "\n            " +
                    _vm._s(
                      _vm.priceList.ProductComponents[0].Energy1PriceUnit
                    ) +
                    "\n        "
                )
              ])
            : _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.getFixedPrice(
                        _vm.priceList.ProductComponents[0]
                          .Energy1BundlePriceNoVat,
                        2
                      )
                    ) +
                    "\n            " +
                    _vm._s(
                      _vm.priceList.ProductComponents[0].Energy1PriceUnit
                    ) +
                    "\n        "
                )
              ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.priceList.ProductComponents[0].Energy2BundleDescription
      ? _c("div", { staticClass: "product-component-detail highlight price" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.priceList.ProductComponents[0].Energy2BundleDescription
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _vm.showVat
            ? _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.getFixedPrice(
                        _vm.priceList.ProductComponents[0].Energy2BundlePrice,
                        2
                      )
                    ) +
                    "\n            " +
                    _vm._s(
                      _vm.priceList.ProductComponents[0].Energy2PriceUnit
                    ) +
                    "\n        "
                )
              ])
            : _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.getFixedPrice(
                        _vm.priceList.ProductComponents[0]
                          .Energy2BundlePriceNoVat,
                        2
                      )
                    ) +
                    "\n            " +
                    _vm._s(
                      _vm.priceList.ProductComponents[0].Energy2PriceUnit
                    ) +
                    "\n        "
                )
              ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.priceList.ProductComponents[0].SpotEnergy1MarginalDescription
      ? _c("div", { staticClass: "product-component-detail highlight price" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.priceList.ProductComponents[0]
                    .SpotEnergy1MarginalDescription
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _vm.showVat
            ? _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.getFixedPrice(
                        _vm.priceList.ProductComponents[0]
                          .SpotEnergy1MarginalPrice,
                        2
                      )
                    ) +
                    "\n            " +
                    _vm._s(
                      _vm.priceList.ProductComponents[0]
                        .SpotEnergy1MarginalPriceUnit
                    ) +
                    "\n        "
                )
              ])
            : _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.getFixedPrice(
                        _vm.priceList.ProductComponents[0]
                          .SpotEnergy1MarginalPriceNoVAT,
                        2
                      )
                    ) +
                    "\n            " +
                    _vm._s(
                      _vm.priceList.ProductComponents[0]
                        .SpotEnergy1MarginalPriceUnit
                    ) +
                    "\n        "
                )
              ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.priceList.ProductComponents[0].SpotEnergy2MarginalDescription
      ? _c("div", { staticClass: "product-component-detail highlight price" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.priceList.ProductComponents[0]
                    .SpotEnergy2MarginalDescription
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _vm.showVat
            ? _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.getFixedPrice(
                        _vm.priceList.ProductComponents[0]
                          .SpotEnergy2MarginalPrice,
                        2
                      )
                    ) +
                    "\n            " +
                    _vm._s(
                      _vm.priceList.ProductComponents[0]
                        .SpotEnergy2MarginalPriceUnit
                    ) +
                    "\n        "
                )
              ])
            : _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.getFixedPrice(
                        _vm.priceList.ProductComponents[0]
                          .SpotEnergy2MarginalPriceNoVAT,
                        2
                      )
                    ) +
                    "\n            " +
                    _vm._s(
                      _vm.priceList.ProductComponents[0]
                        .SpotEnergy2MarginalPriceUnit
                    ) +
                    "\n        "
                )
              ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "product-component-detail price" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.priceList.ProductComponents[0].BasicDescription) +
            "\n        "
        )
      ]),
      _vm._v(" "),
      _vm.showVat
        ? _c("div", { staticClass: "value" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.getFixedPrice(
                    _vm.priceList.ProductComponents[0].BasicPrice,
                    2
                  )
                ) +
                "\n            " +
                _vm._s(_vm.priceList.ProductComponents[0].BasicPriceUnit) +
                "\n        "
            )
          ])
        : _c("div", { staticClass: "value" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.getFixedPrice(
                    _vm.priceList.ProductComponents[0].BasicPriceNoVAT,
                    2
                  )
                ) +
                "\n            " +
                _vm._s(_vm.priceList.ProductComponents[0].BasicPriceUnit) +
                "\n        "
            )
          ])
    ]),
    _vm._v(" "),
    _vm.priceList.ProductComponents[0].SpotPriceLimitFeeDescription
      ? _c("div", { staticClass: "product-component-detail price" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.priceList.ProductComponents[0]
                    .SpotPriceLimitFeeDescription
                ) +
                "\n        "
            )
          ]),
          _vm._v(" "),
          _vm.showVat
            ? _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.getFixedPrice(
                        _vm.priceList.ProductComponents[0].SpotPriceLimitFee,
                        2
                      )
                    ) +
                    "\n            " +
                    _vm._s(
                      _vm.priceList.ProductComponents[0].SpotPriceLimitFeeUnit
                    ) +
                    "\n        "
                )
              ])
            : _c("div", { staticClass: "value" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.getFixedPrice(
                        _vm.priceList.ProductComponents[0]
                          .SpotPriceLimitFeeNoVAT,
                        2
                      )
                    ) +
                    "\n            " +
                    _vm._s(
                      _vm.priceList.ProductComponents[0].SpotPriceLimitFeeUnit
                    ) +
                    "\n        "
                )
              ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.priceList.CountOfMandatoryServiceProducts > 0
      ? _c(
          "div",
          [
            _vm.priceList.CountOfMandatoryServiceProducts === 1
              ? _c("div", { staticClass: "font-weight-bold pt-0" }, [
                  _vm._v(_vm._s(_vm.$t("Tuotteeseen sisältyvä lisäpalvelu")))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.priceList.CountOfMandatoryServiceProducts > 1
              ? _c("div", { staticClass: "font-weight-bold pt-0" }, [
                  _vm._v(_vm._s(_vm.$t("Tuotteeseen sisältyvät lisäpalvelut")))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.priceList.PriceListServiceProducts, function(sp) {
              return _c("div", [
                sp.PriceListServiceProductType == 2
                  ? _c("div", [
                      _vm.showVat
                        ? _c("div", { staticClass: "value" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.getFixedPrice(sp.ServicePriceList.Name) +
                                    " " +
                                    _vm._s(
                                      sp.ServicePriceList.ProductComponents[0]
                                        .ServicePrice,
                                      2
                                    )
                                ) +
                                " " +
                                _vm._s(
                                  sp.ServicePriceList.ProductComponents[0]
                                    .ServicePriceUnitTranslated
                                ) +
                                "\n                "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showVat
                        ? _c("div", { staticClass: "value" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(sp.ServicePriceList.Name) +
                                " " +
                                _vm._s(
                                  _vm.getFixedPrice(
                                    sp.ServicePriceList.ProductComponents[0]
                                      .ServicePriceNoVAT,
                                    2
                                  )
                                ) +
                                " " +
                                _vm._s(
                                  sp.ServicePriceList.ProductComponents[0]
                                    .ServicePriceUnitTranslated
                                ) +
                                "\n                "
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ])
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.priceList.CountOfOptionalServiceProducts > 0
      ? _c(
          "div",
          [
            _vm.priceList.CountOfOptionalServiceProducts === 1
              ? _c("div", { staticClass: "font-weight-bold pt-0" }, [
                  _vm._v(_vm._s(_vm.$t("Tuotteeseen valittu lisäpalvelu")))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.priceList.CountOfOptionalServiceProducts > 1
              ? _c("div", { staticClass: "font-weight-bold pt-0" }, [
                  _vm._v(_vm._s(_vm.$t("Tuotteeseen valitut lisäpalvelut")))
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.priceList.PriceListServiceProducts, function(sp) {
              return _c("div", [
                sp.PriceListServiceProductType == 1
                  ? _c("div", [
                      _vm.showVat
                        ? _c("div", { staticClass: "value" }, [
                            _c("label", { staticClass: "checkbox-inline" }, [
                              _c("input", {
                                attrs: {
                                  type: "checkbox",
                                  name: "ServiceProduct",
                                  disabled: "disabled"
                                },
                                domProps: {
                                  checked: _vm.isServiceProductSelected(
                                    _vm.priceList.Id,
                                    sp.ServicePriceList.ExternalPriceListId
                                  )
                                }
                              }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(sp.ServicePriceList.Name) +
                                  " " +
                                  _vm._s(
                                    _vm.getFixedPrice(
                                      sp.ServicePriceList.ProductComponents[0]
                                        .ServicePrice,
                                      2
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    sp.ServicePriceList.ProductComponents[0]
                                      .ServicePriceUnitTranslated
                                  ) +
                                  "\n                    "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.showVat
                        ? _c("div", { staticClass: "value" }, [
                            _c("label", { staticClass: "checkbox-inline" }, [
                              _c("input", {
                                attrs: {
                                  type: "checkbox",
                                  name: "ServiceProduct",
                                  disabled: "disabled"
                                },
                                domProps: {
                                  checked: _vm.isServiceProductSelected(
                                    _vm.priceList.Id,
                                    sp.ServicePriceList.ExternalPriceListId
                                  )
                                }
                              }),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(sp.ServicePriceList.Name) +
                                  " " +
                                  _vm._s(
                                    _vm.getFixedPrice(
                                      sp.ServicePriceList.ProductComponents[0]
                                        .ServicePriceNoVAT,
                                      2
                                    )
                                  ) +
                                  " " +
                                  _vm._s(
                                    sp.ServicePriceList.ProductComponents[0]
                                      .ServicePriceUnitTranslated
                                  ) +
                                  "\n                    "
                              )
                            ])
                          ])
                        : _vm._e()
                    ])
                  : _vm._e()
              ])
            })
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.showVat
      ? _c("div", [
          _vm._v("\n        " + _vm._s(_vm.$t("(Hinnat alv 0%)")) + "\n    ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "product-component-detail" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v("\n            " + _vm._s(_vm.$t("Voimassa")) + "\n        ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "value" }, [
        _vm._v(
          "\n            " +
            _vm._s(_vm.formatDuration(_vm.contract, _vm.priceList)) +
            "\n        "
        )
      ])
    ]),
    _vm._v(" "),
    _vm.showEnergyType()
      ? _c("div", { staticClass: "product-component-detail" }, [
          _c("div", { staticClass: "title" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.$t("Tuotantomuoto")) + "\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "value" }, [
            _vm._v(
              "\n            " + _vm._s(_vm.getEnergyType()) + "\n        "
            )
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }